<template>
  <div id="recetas">
    <div class="msg">
      <h2 class="titulo">RECETAS</h2>
    </div>
    <div class="container">
      <div class="group">
         <div class="color amarillo"></div>
           <router-link to="/bebidaNectarina">
        <div class="receta"><img src="@/assets/images/recetas/1-min.jpg" alt=""></div>
      </router-link>
      </div>
      <div class="group">
         <div class="color azul"></div>
          <router-link to="/smoothie">
        <div class="receta"><img src="@/assets/images/recetas/2-min.jpg" alt=""></div>
      </router-link>
      </div>
      <div class="group">
         <div class="color amarillo"></div>
            <router-link to="/volovanesFrutas">
        <div class="receta"><img src="@/assets/images/recetas/3-min.jpg" alt=""></div>
      </router-link>
      </div>
      <div class="group">
         <div class="color amarillo"></div>
         <router-link to="/merengueFresas">
        <div class="receta"><img src="@/assets/images/recetas/4-min.jpg" alt=""></div>
      </router-link>
      </div>
      <div class="group">
         <div class="color  azul"></div>
          <router-link to="/fresasChocolate">
        <div class="receta"><img src="@/assets/images/recetas/5-min.jpg" alt=""></div>
      </router-link>
      </div>
      <div class="group">
         <div class="color amarillo"></div>
         <router-link to="/tortaCiruelas">
        <div class="receta"><img src="@/assets/images/recetas/6-min.jpg" alt=""></div>
      </router-link>
      </div>
      <div class="group">
         <div class="color amarillo"></div>
          <router-link to="/ensalada">
        <div class="receta"><img src="@/assets/images/recetas/7-min.jpg" alt=""></div>
      </router-link>
      </div>
      <div class="group">
         <div class="color azul"></div>
          <router-link to="/smoothieManzana">
        <div class="receta"><img src="@/assets/images/recetas/8-min.jpg" alt=""></div>
      </router-link>
      </div>
      <div class="group">
         <div class="color amarillo"></div>
           <router-link to="/ensaladaMelon">
        <div class="receta"><img src="@/assets/images/recetas/9-min.jpg" alt=""></div>
      </router-link>
      </div>
      <div class="group">
         <div class="color amarillo"></div>
          <router-link to="puddingMango">
        <!-- <div class="receta"><img src="@/assets/images/recetas/10-min.jpg" alt=""></div> -->
        <div class="receta fondo"></div>
      </router-link>
      </div>

    </div>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>

  #recetas {
    div.container {
      height: 160vh;
    }
     .container .group {
      height: 40vh;
    }
    .msg {

     .titulo {
      font-weight: bold;
      font-size: 2.2em;
      text-align: center;
      color: #000;
     }
    }

      .fondo {
        background: url('../assets/images/recetas/10-min.jpg');
        background-position: center top;
        background-size: 100%;
        background-repeat: no-repeat;
      }

      .receta {
        width: 100%;
        height: 100%;

        img {
          width: 100%;
          max-width: 100%;
          height: 100%;
        }
      }
    }
</style>
